import API from '@/api';
import popup from './popup.store.js';

export default {
  namespaced: true,
  modules: {
    'popup': popup,
  },
  state: {
    loading: false,
    data: [],
    pageCount: 0,
    fertilizer: {
      id: false,
      name: false,
      type: false,
      general: false,
      solubility: false,
      macro: false,
      micro: false,
      cost: 0,
      unit: 0,
    },
    id: '',
    type: 'all',
    search: '',
    page: '0',
    take: '10',
    typeAlias: {
      '1': 'SOLID',
      '2': 'SOLID',
      '5': 'SOLID',
      '3': 'Acid',
      '4': 'Liquid',
      '6': 'Liquid',
    },
    arrayMicro: ['B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo', 'Cl'],
    arrayMacro: {
      before: ['NO3', 'NH4', 'NH2'],
      after: ['P', 'K', 'Ca', 'Mg', 'S', 'CO3', 'HCO3', 'Na']
    },
    original: {},
    userId: '',
    cost: {
      price: 0,
      unit: null,
    },
  },
  mutations: {
    saveData (state, data) {
      var new_arr = data.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          type: state.typeAlias[item.stateId]
        };
      });

      state.data = new_arr;
    },
    savePageCount (state, pages) {
      if (state.data.length > 0) {
        state.pageCount = pages;
      } else {
        state.pageCount = 0;
      }

    },
    saveId (state, id) {
      state.id = id;
    },
    saveType (state, type) {
      state.type = type;
    },
    savePage (state, page) {
      state.page = page;
    },
    saveSearch (state, value) {
      state.search = value;
    },
    saveFertilizer (state, fert) {
      console.log(fert);
      state.fertilizer.id = fert.id;
      state.fertilizer.name = fert.name;
      state.fertilizer.type = state.typeAlias[fert.stateId];
      state.fertilizer.cost = fert.cost;
      state.fertilizer.unit = fert.unit;
    },
    saveFertilizerGeneral (state, fert) {
      var result = {
        density: {
          name: 'Density',
          value: '-'
        },
        baseDressing: {
          name: 'Base dressing',
          value: '-'
        },
        compound: {
          name: 'Compound',
          value: '-'
        },
      };

      if (fert.isBaseDressing == '1') {
        result.baseDressing.value = 'Available';
      }
      if (fert.isCompound == '1') {
        result.compound.value = 'Available';
      }
      if (Number(fert.data.Fertilizer['SpecificWeight']) > 0) {
        result.density.value =
          Number(fert.data.Fertilizer['SpecificWeight']) % 1000 == 0 ?
            Number(fert.data.Fertilizer['SpecificWeight']) / 1000 :
            Number(fert.data.Fertilizer['SpecificWeight']);
      }

      state.fertilizer.general = result;
    },
    saveFertilizerSolubility (state, solubility = false) {
      if (!solubility) {
        state.fertilizer.solubility = false;
        return true;
      }

      state.fertilizer.solubility = {};

      for (var i = 0; i <= 30; i += 5) {
        state.fertilizer.solubility[i + 'C'] = '-';
      }
      for (var key in solubility) {
        var regTemplate = /Sol_(\d+C)/;
        var regArray = regTemplate.exec(key);

        state.fertilizer.solubility[regArray[1]] = Number(solubility[key]);
      }
    },
    saveFertilizerMacro (state, fert) {
      state.fertilizer.macro = false;
      var result = {before: {}, after: {}};

      var nutrients = fert.data.Fertilizer.ElementsConcentration;

      for (var key in nutrients) {
        var regTemplate = /(\w+)_Val/;
        var regArray = regTemplate.exec(key);

        if (regArray && state.arrayMacro.before.indexOf(regArray[1]) != -1  && Number(nutrients[key]) > 0) {
          result.before[regArray[1]] = Number(nutrients[key]);
        } else if (regArray && state.arrayMacro.after.indexOf(regArray[1]) != -1  && Number(nutrients[key]) > 0) {
          result.after[regArray[1]] = Number(nutrients[key]);
        }
      }

      if (Object.keys(result.before).length > 0 || Object.keys(result.after).length > 0) {
        state.fertilizer.macro = result;
      }
    },
    saveFertilizerMicro (state, fert) {
      state.fertilizer.micro = false;
      var result = {};

      var nutrients = fert.data.Fertilizer.ElementsConcentration;

      for (var key in nutrients) {
        var regTemplate = /(\w+)_Val/;
        var regArray = regTemplate.exec(key);

        if (regArray && state.arrayMicro.indexOf(regArray[1]) != -1 && Number(nutrients[key]) > 0) {
          result[regArray[1]] = Number(nutrients[key]);
        }
      }

      if (Object.keys(result).length > 0) {
        state.fertilizer.micro = result;
      }

    },
    setOriginal (state, data) {
      state.original = data;
    },
    setLoading(state, bool) {
      // console.log(bool);
      state.loading = bool;
    }
  },
  actions: {
    getFertilizers ({ commit, state }) {

      var data = {
        page: state.page,
        take: state.take
      };

      if (state.search != '') {
        data.search = state.search;
      }
      if (state.type != 'ALL') {
        data.type = state.type;
      }

      return API.fertilizers.getFertilizers(data).then(res => {
        // console.log(res);
        commit('saveData', res.data.data.data);
        commit('savePageCount', res.data.data.pages);

        return res;
      });
    },
    getFertilizer ({ commit, state, rootGetters }) {
      commit('setLoading', true);
      if(state.id==0 || state.id==null)
      { 
        console.log('null')
        commit('setLoading', false);
      }
      else
      {
      //======================================================================================
      return API.fertilizers.getFertilizer(state.id).then(res => {
        let result = JSON.parse(JSON.stringify(res));
        console.log(result.data.message)
        if (result.data.message == "Please buy a plan!") {
          
          console.log(result.data.message)
          throw new Error("Please buy a plan")
          
        }
        else{
        state.userId = rootGetters['user/data'].id;
        commit('setOriginal', res.data.data);
        commit('saveFertilizer', res.data.data);
        commit('saveFertilizerGeneral', res.data.data);
        if (res.data.data.data.Fertilizer.Solubility) {
          commit('saveFertilizerSolubility', res.data.data.data.Fertilizer.Solubility);
        } else {
          commit('saveFertilizerSolubility');
        }
        commit('saveFertilizerMacro', res.data.data);
        commit('saveFertilizerMicro', res.data.data);
        commit('setLoading', false);
        
        return res;
      }})
      //======================================================================================
    }
    },
    deleteFertilizer ({ commit, state }) {
      return API.fertilizers.deleteFertilizer(state.id).then(res => {
        if (res.success == true) {
          state.fertilizer.id = false;
          state.fertilizer.name = false;
          state.fertilizer.type = false;
          state.fertilizer.general = false;
          state.fertilizer.solubility = false;
          state.fertilizer.macro = false;
          state.fertilizer.micro = false;
          state.original = {};
        }
        return res;
      });
    }
  },
  getters: {
    getFertilizersAll (state) {
      return state.data;
    },
    getId (state) {
      return state.id;
    },
    getGeneral (state) {
      return state.fertilizer.general;
    },
    getType (state) {
      return state.type.toLowerCase();
    },
    getPage (state) {
      return state.page;
    },
    getPageCount (state) {
      return state.pageCount;
    },
    getFertilizer (state) {
      return state.fertilizer;
    },
    original (state) {
      return state.original;
    },
    loading(state) {
      return state.loading;
    },
    userCost(state) {
      return {
        id: state.id,
        price: state.cost.price,
        unit: state.cost.unit,
      }
    },
    isUser: state => {
      if (state.original.isSystem === 0 && state.original.owner == state.userId) {
        return true;
      }

      return false;
    }
  }
}
